export const login = {
    header: {
        welcome: 'Welcome!',
        slogan: 'Use these awesome forms to login or create new account in your project for free.',
    },
    loginForm: {
        title: 'Sign in',
        email: 'Email',
        password: 'Password',
        forgotPassword: 'Forgot Password',
        loginByLdap: 'Sign in by LDAP',
        signIn: 'Sign in',
        or: 'or',
        register: 'Register',
        loginOtherAccount: 'Use another account',
    },
    loginLdapForm: {
        title: 'Sign in',
        subTitle: 'Use your LDAP Account',
        username: 'LDAP Username',
        password: 'Password',
        signIn: 'Sign in',
    },

    message: {
        title: 'Notification',
        logoutOtherDevice: {
            title: 'Notification',
            confirmAsk:
                'This account is being signed in on another device. Do you want to sign out of this account from all other devices?',
            success: 'Sign out from other devices successfully',
        },
    },
    otp: {
        title: 'Verify OTP',
        resend: 'Resend',
        quit: 'Quit',
    },
};
